export default "__VITE_ASSET__CjlCUZSB__"